
// import React, { useState, useEffect } from 'react';
// import { Box, Grid, Typography, Link, useMediaQuery, CircularProgress } from '@mui/material';
// import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import { useTabContext } from './TabContext';

// import BedIcon from '@mui/icons-material/Bed';
// import SquareFootIcon from '@mui/icons-material/SquareFoot';
// import ApartmentIcon from '@mui/icons-material/Apartment';
// import BathtubIcon from '@mui/icons-material/Bathtub';

// const getAmenityIcon = (amenityType) => {
//   const amenityIconMap = {
//     'bed': <BedIcon sx={{ color: '#626262', fontSize: 20 }} />,
//     'area': <SquareFootIcon sx={{ color: '#626262', fontSize: 20 }} />,
//     'floor': <ApartmentIcon sx={{ color: '#626262', fontSize: 20 }} />,
//     'bath': <BathtubIcon sx={{ color: '#626262', fontSize: 20 }} />
//   };

//   return amenityIconMap[amenityType] || <SquareFootIcon sx={{ color: '#626262', fontSize: 20 }} />;
// };

// const ResidentialProperties = () => {
//   const theme = useTheme();
//   const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const navigate = useNavigate();
//   const { activeTab } = useTabContext();

//   const [properties, setProperties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const isLoggedIn = useSelector(state => state.user.isAuthenticated);
//   const userData = useSelector(state => state.user.user);

//   const categoryMap = {
//     'Buy': 'sale',
//     'Rent': 'rent',
//     'Plot': 'plot',
//   };

//   useEffect(() => {
//     const fetchResidentialProperties = async () => {
//       try {
//         setLoading(true);
//         const categoryType = categoryMap[activeTab];
        
//         let url = 'https://propertydealstalk.com/api/property/filterProperties?property_type=residential';
        
//         if (activeTab === 'Plot') {
//           url = 'https://propertydealstalk.com/api/property/filterProperties?property_type=residential&asset_type=plot';
//         } else if (categoryType) {
//           url += `&category=${categoryType}`;
//         }

//         const response = await fetch(url);

//         if (!response.ok) {
//           throw new Error('Failed to fetch residential properties');
//         }

//         const data = await response.json();

//         if (data.statusCode === 200 && data.result && data.result.properties) {
//           setProperties(data.result.properties);
//         } else {
//           throw new Error(data.message || 'Failed to get property data');
//         }
//       } catch (err) {
//         console.error('Error fetching residential properties:', err);
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchResidentialProperties();
//   }, [activeTab]);

//   const recordPropertyView = async (propertyId) => {
//     if (!isLoggedIn || !userData) {
//       return;
//     }

//     try {
//       const userId = userData.id;
//       if (!userId) {
//         return;
//       }

//       const response = await fetch('https://propertydealstalk.com/api/buyer/recordPropertyView', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           user_id: userId,
//           property_id: propertyId
//         }),
//       });

//       const data = await response.json();
//       if (data.statusCode === 200) {
//         console.log('Property view recorded successfully');
//       }
//     } catch (err) {
//       console.error('Error recording property view:', err);
//     }
//   };

//   const hasValidImage = (base64) => {
//     return base64 && base64.length > 100;
//   };

//   const isValidValue = (value) => {
//     return value && value !== 'N/A' && value !== 'null' && value !== null && value !== undefined && value.toString().trim() !== '';
//   };

//   const formatPrice = (price) => {
//     if (!price || price === 0 || price === '0') return '';
    
//     const priceStr = price.toString();
//     const lastThree = priceStr.substring(priceStr.length - 3);
//     const otherNumbers = priceStr.substring(0, priceStr.length - 3);
    
//     if (otherNumbers !== '') {
//       return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree;
//     }
    
//     return lastThree;
//   };

//   const getDisplayPrice = (property) => {
//     const category = property.category || property.commercial_catgory || '';
//     const isRental = category.toLowerCase() === 'rent';

//     if (isRental) {
//       if (isValidValue(property.monthly_rent) && property.monthly_rent !== 0) {
//         return property.monthly_rent;
//       }
//     }

//     if (isValidValue(property.asking_price) && property.asking_price !== 0) {
//       return property.asking_price;
//     }

//     return null;
//   };

//   const getTimeAgo = (dateString) => {
//     if (!dateString) return '';
    
//     const date = new Date(dateString);
//     const now = new Date();
//     const diffInSeconds = Math.floor((now - date) / 1000);
    
//     const intervals = {
//       y: 31536000,
//       mo: 2592000,
//       w: 604800,
//       d: 86400,
//       h: 3600,
//       m: 60,
//       s: 1
//     };
    
//     for (const [key, value] of Object.entries(intervals)) {
//       const interval = Math.floor(diffInSeconds / value);
//       if (interval >= 1) {
//         return `${interval}${key} ago`;
//       }
//     }
    
//     return 'just now';
//   };

//   const handleViewAllClick = (e) => {
//     e.preventDefault();
//     navigate('/residential-view');
//   };

//   const handlePropertyClick = (propertyId) => {
//     recordPropertyView(propertyId);
//     navigate(`/view/${propertyId}`);
//   };

//   const displayedProperties = properties.slice(0, 8);

//   const getPropertyAmenities = (property) => {
//     const amenities = [];

//     if (isValidValue(property.property_size)) {
//       const sizeUnit = isValidValue(property.property_size_units) ? property.property_size_units : 'sq.ft';
//       amenities.push({
//         type: 'area',
//         value: `${property.property_size} ${sizeUnit}`
//       });
//     }

//     if (isValidValue(property.bhk)) {
//       amenities.push({
//         type: 'bed',
//         value: `${property.bhk} BHK`
//       });
//     }

//     if (isValidValue(property.select_floor) && isValidValue(property.total_floors)) {
//       amenities.push({
//         type: 'floor',
//         value: `${property.select_floor}/${property.total_floors} Floor`
//       });
//     }

//     return amenities;
//   };

//   const getSectionTitle = () => {
//     switch (activeTab) {
//       case 'Buy':
//         return 'Residential Property Deals for Sale';
//       case 'Rent':
//         return 'Residential Property Deals for Rent';
//       case 'Plot':
//         return 'Residential Plot Deals';
//       default:
//         return 'Residential Property Deals';
//     }
//   };

//   const getSectionSubtitle = () => {
//     switch (activeTab) {
//       case 'Buy':
//         return 'Premium properties available for purchase';
//       case 'Rent':
//         return 'Find your perfect rental home';
//       case 'Plot':
//         return 'Prime residential plots in top locations';
//       default:
//         return 'Leading Project in high demand';
//     }
//   };

//   return (
//     <Box
//       sx={{
//         px: '40px',
//         pb: '40px',
//         fontFamily: 'Outfit',
//         bgcolor: '#F9FAFB',
//       }}
//     >
//       <Box
//         sx={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'flex-end',
//           py: '30px',
//         }}
//       >
//         <Box>
//           <Typography sx={{ fontSize: 24, fontWeight: 600, m: 0 }}>
//             {getSectionTitle()}
//           </Typography>
//           <Typography sx={{ fontSize: 14, color: '#626262', mt: '4px', fontWeight: 400 }}>
//             {getSectionSubtitle()}
//           </Typography>
//         </Box>
//         <Link
//           href="#"
//           underline="none"
//           sx={{ fontWeight: 500, color: '#626262' }}
//           onClick={handleViewAllClick}
//         >
//           View All
//         </Link>
//       </Box>

//       {loading ? (
//         <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
//           <CircularProgress />
//         </Box>
//       ) : error ? (
//         <Box sx={{ textAlign: 'center', py: 4, color: 'error.main' }}>
//           <Typography>{error}</Typography>
//         </Box>
//       ) : (
//         <Grid
//           container
//           spacing={2}
//           sx={{
//             display: 'grid',
//             gridTemplateColumns: isMobile
//               ? '1fr'
//               : isTablet
//               ? 'repeat(2, 1fr)'
//               : 'repeat(4, 1fr)',
//             gap: '20px',
//           }}
//         >
//           {displayedProperties.map((property) => {
//             const amenities = getPropertyAmenities(property);
//             const hasImage = hasValidImage(property.image);
//             const displayPrice = getDisplayPrice(property);
//             const isRental = (property.category || property.commercial_catgory || '').toLowerCase() === 'rent';
//             const timeAgo = getTimeAgo(property.createdAt);

//             return (
//               <Box
//                 key={property.id}
//                 sx={{
//                   display: 'flex',
//                   flexDirection: isMobile ? 'column' : 'row',
//                   height: isMobile ? 'auto' : '200px',
//                   bgcolor: '#fff',
//                   border: '1px solid #D1D5DB',
//                   borderRadius: '12px',
//                   overflow: 'hidden',
//                   boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
//                   transition: 'transform 0.2s, box-shadow 0.2s',
//                   cursor: 'pointer',
//                   '&:hover': {
//                     transform: 'translateY(-4px)',
//                     boxShadow: '0 8px 20px rgba(0,0,0,0.1)',
//                   },
//                 }}
//                 onClick={() => handlePropertyClick(property.id)}
//               >
//                 <Box
//                   sx={{
//                     width: isMobile ? '100%' : '50%',
//                     height: isMobile ? '200px' : '100%',
//                     position: 'relative',
//                     overflow: 'hidden',
//                   }}
//                 >
//                   {hasImage ? (
//                     <Box
//                       component="img"
//                       src={`data:image/png;base64,${property.image}`}
//                       alt={property.property_name}
//                       sx={{
//                         width: '100%',
//                         height: '100%',
//                         objectFit: 'cover',
//                       }}
//                     />
//                   ) : (
//                     <Box
//                       sx={{
//                         width: '100%',
//                         height: '100%',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         backgroundColor: '#f5f5f5',
//                         border: '1px dashed #ccc'
//                       }}
//                     >
//                       <Typography variant="body2" color="#888" textAlign="center" px={2}>
//                         No images uploaded
//                       </Typography>
//                     </Box>
//                   )}

//                   {timeAgo && (
//                     <Box
//                       sx={{
//                         position: 'absolute',
//                         bottom: '8px',
//                         right: '8px',
//                         bgcolor: 'rgba(0, 0, 0, 0.7)',
//                         color: '#fff',
//                         px: '8px',
//                         py: '4px',
//                         borderRadius: '4px',
//                         fontSize: '11px',
//                         fontWeight: 500,
//                         zIndex: 2,
//                         fontFamily: 'Outfit, sans-serif',
//                       }}
//                     >
//                       {timeAgo}
//                     </Box>
//                   )}
//                 </Box>

//                 <Box
//                   sx={{
//                     width: isMobile ? '100%' : '50%',
//                     p: 1.5,
//                     display: 'flex',
//                     flexDirection: 'column',
//                     justifyContent: 'space-between',
//                     boxSizing: 'border-box',
//                     overflow: 'hidden',
//                   }}
//                 >
//                   <Typography
//                     sx={{
//                       fontSize: 14,
//                       fontWeight: 500,
//                       color: '#000',
//                       overflow: 'hidden',
//                       textOverflow: 'ellipsis',
//                       whiteSpace: 'nowrap',
//                       mb: 0.5
//                     }}
//                   >
//                     {property.property_name}
//                   </Typography>

//                   {property.added_by && property.added_by.full_name ? (
//                     <Typography
//                       sx={{
//                         fontSize: 11,
//                         color: '#626262',
//                         fontWeight: 400,
//                         overflow: 'hidden',
//                         textOverflow: 'ellipsis',
//                         whiteSpace: 'nowrap',
//                         mb: 0.5
//                       }}
//                     >
//                       by {property.added_by.full_name}
//                     </Typography>
//                   ) : (
//                     <Box sx={{ height: '16px', mb: 0.5 }} />
//                   )}

//                   <Typography
//                     sx={{
//                       fontSize: 11,
//                       color: '#626262',
//                       fontWeight: 400,
//                       overflow: 'hidden',
//                       textOverflow: 'ellipsis',
//                       whiteSpace: 'nowrap',
//                       mb: 0.5
//                     }}
//                   >
//                     {property.area_name}, {property.location}
//                   </Typography>

//                   {amenities.length > 0 && (
//                     <Box
//                       sx={{
//                         display: 'flex',
//                         flexDirection: 'column',
//                         gap: '3px',
//                         mb: 0.5
//                       }}
//                     >
//                       {amenities.map((amenity, index) => (
//                         <Box
//                           key={index}
//                           component="span"
//                           sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}
//                         >
//                           {getAmenityIcon(amenity.type)}
//                           <Typography
//                             sx={{
//                               fontSize: 11,
//                               color: '#626262',
//                               overflow: 'hidden',
//                               textOverflow: 'ellipsis',
//                               whiteSpace: 'nowrap'
//                             }}
//                           >
//                             {amenity.value}
//                           </Typography>
//                         </Box>
//                       ))}
//                     </Box>
//                   )}

//                   <Typography
//                     sx={{
//                       fontWeight: 600,
//                       color: '#2563EB',
//                       fontSize: 15,
//                       overflow: 'hidden',
//                       textOverflow: 'ellipsis',
//                       whiteSpace: 'nowrap',
//                       width: '100%'
//                     }}
//                   >
//                     {displayPrice ? (
//                       <>
//                         ₹ {formatPrice(displayPrice)}
//                         {isRental && '/month'}
//                       </>
//                     ) : (
//                       'Price on Request'
//                     )}
//                   </Typography>
//                 </Box>
//               </Box>
//             );
//           })}
//         </Grid>
//       )}
//     </Box>
//   );
// };

// export default ResidentialProperties;



import React, { useState, useEffect } from 'react';
import { Box, Grid, Typography, Link, useMediaQuery, CircularProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTabContext } from './TabContext';

import BedIcon from '@mui/icons-material/Bed';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import ApartmentIcon from '@mui/icons-material/Apartment';
import BathtubIcon from '@mui/icons-material/Bathtub';

const getAmenityIcon = (amenityType) => {
  const amenityIconMap = {
    'bed': <BedIcon sx={{ color: '#626262', fontSize: 20 }} />,
    'area': <SquareFootIcon sx={{ color: '#626262', fontSize: 20 }} />,
    'floor': <ApartmentIcon sx={{ color: '#626262', fontSize: 20 }} />,
    'bath': <BathtubIcon sx={{ color: '#626262', fontSize: 20 }} />
  };

  return amenityIconMap[amenityType] || <SquareFootIcon sx={{ color: '#626262', fontSize: 20 }} />;
};

const ResidentialProperties = () => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const { activeTab } = useTabContext();

  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const isLoggedIn = useSelector(state => state.user.isAuthenticated);
  const userData = useSelector(state => state.user.user);

  const categoryMap = {
    'Buy': 'sale',
    'Rent': 'rent',
    'Plot': 'plot',
  };

  // Function to get user-friendly error message
  const getUserFriendlyErrorMessage = (error) => {
    const errorString = error.toString().toLowerCase();
    
    if (errorString.includes('fetch') || 
        errorString.includes('network') || 
        errorString.includes('failed to fetch') ||
        errorString.includes('networkerror') ||
        errorString.includes('connection')) {
      return 'Unable to load the properties. Please check your internet connection and try again.';
    }
    
    if (errorString.includes('timeout')) {
      return 'Unable to load the properties. Please check your internet connection and try again.';
    }
    
    if (errorString.includes('500') || errorString.includes('server error')) {
      return 'Unable to load the properties. Please check your internet connection and try again.';
    }
    
    if (errorString.includes('404') || errorString.includes('not found')) {
      return 'Unable to load the properties. Please check your internet connection and try again.';
    }
    
    return 'Unable to load the properties. Please check your internet connection and try again.';
  };

  useEffect(() => {
    const fetchResidentialProperties = async () => {
      try {
        setLoading(true);
        setError(null);
        const categoryType = categoryMap[activeTab];
        
        let url = 'https://propertydealstalk.com/api/property/filterProperties?property_type=residential';
        
        if (activeTab === 'Plot') {
          url = 'https://propertydealstalk.com/api/property/filterProperties?property_type=residential&asset_type=plot';
        } else if (categoryType) {
          url += `&category=${categoryType}`;
        }

        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        if (data.statusCode === 200 && data.result && data.result.properties) {
          setProperties(data.result.properties);
        } else {
          throw new Error('Unable to load properties');
        }
      } catch (err) {
        console.error('Error fetching residential properties:', err);
        const friendlyMessage = getUserFriendlyErrorMessage(err);
        setError(friendlyMessage);
      } finally {
        setLoading(false);
      }
    };

    fetchResidentialProperties();
  }, [activeTab]);

  const recordPropertyView = async (propertyId) => {
    if (!isLoggedIn || !userData) {
      return;
    }

    try {
      const userId = userData.id;
      if (!userId) {
        return;
      }

      const response = await fetch('https://propertydealstalk.com/api/buyer/recordPropertyView', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: userId,
          property_id: propertyId
        }),
      });

      const data = await response.json();
      if (data.statusCode === 200) {
        console.log('Property view recorded successfully');
      }
    } catch (err) {
      console.error('Error recording property view:', err);
    }
  };

  const hasValidImage = (base64) => {
    return base64 && base64.length > 100;
  };

  const isValidValue = (value) => {
    return value && value !== 'N/A' && value !== 'null' && value !== null && value !== undefined && value.toString().trim() !== '';
  };

  const formatPrice = (price) => {
    if (!price || price === 0 || price === '0') return '';
    
    const priceStr = price.toString();
    const lastThree = priceStr.substring(priceStr.length - 3);
    const otherNumbers = priceStr.substring(0, priceStr.length - 3);
    
    if (otherNumbers !== '') {
      return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree;
    }
    
    return lastThree;
  };

  const getDisplayPrice = (property) => {
    const category = property.category || property.commercial_catgory || '';
    const isRental = category.toLowerCase() === 'rent';

    if (isRental) {
      if (isValidValue(property.monthly_rent) && property.monthly_rent !== 0) {
        return property.monthly_rent;
      }
    }

    if (isValidValue(property.asking_price) && property.asking_price !== 0) {
      return property.asking_price;
    }

    return null;
  };

  const getTimeAgo = (dateString) => {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);
    
    const intervals = {
      y: 31536000,
      mo: 2592000,
      w: 604800,
      d: 86400,
      h: 3600,
      m: 60,
      s: 1
    };
    
    for (const [key, value] of Object.entries(intervals)) {
      const interval = Math.floor(diffInSeconds / value);
      if (interval >= 1) {
        return `${interval}${key} ago`;
      }
    }
    
    return 'just now';
  };

  const handleViewAllClick = (e) => {
    e.preventDefault();
    navigate('/residential-view');
  };

  const handlePropertyClick = (propertyId) => {
    recordPropertyView(propertyId);
    navigate(`/view/${propertyId}`);
  };

  const displayedProperties = properties.slice(0, 8);

    const getPropertyAmenities = (property) => {
    const amenities = [];

    if (isValidValue(property.property_size)) {
      const sizeUnit = isValidValue(property.property_size_units) ? property.property_size_units : 'sq.ft';
      amenities.push({
        type: 'area',
        value: `${property.property_size} ${sizeUnit}`
      });
    }

    if (isValidValue(property.bhk)) {
      amenities.push({
        type: 'bed',
        value: `${property.bhk} BHK`
      });
    }

    if (isValidValue(property.select_floor) && isValidValue(property.total_floors)) {
      amenities.push({
        type: 'floor',
        value: `${property.select_floor}/${property.total_floors} Floor`
      });
    }

    return amenities;
  };

  const getSectionTitle = () => {
    switch (activeTab) {
      case 'Buy':
        return 'Residential Property Deals for Sale';
      case 'Rent':
        return 'Residential Property Deals for Rent';
      case 'Plot':
        return 'Residential Plot Deals';
      default:
        return 'Residential Property Deals';
    }
  };

  const getSectionSubtitle = () => {
    switch (activeTab) {
      case 'Buy':
        return 'Premium properties available for purchase';
      case 'Rent':
        return 'Find your perfect rental home';
      case 'Plot':
        return 'Prime residential plots in top locations';
      default:
        return 'Leading Project in high demand';
    }
  };

  return (
    <Box
      sx={{
        px: '40px',
        pb: '40px',
        fontFamily: 'Outfit',
        bgcolor: '#F9FAFB',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
          py: '30px',
        }}
      >
        <Box>
          <Typography sx={{ fontSize: 24, fontWeight: 600, m: 0 }}>
            {getSectionTitle()}
          </Typography>
          <Typography sx={{ fontSize: 14, color: '#626262', mt: '4px', fontWeight: 400 }}>
            {getSectionSubtitle()}
          </Typography>
        </Box>
        <Link
          href="#"
          underline="none"
          sx={{ fontWeight: 500, color: '#626262' }}
          onClick={handleViewAllClick}
        >
          View All
        </Link>
      </Box>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Box 
          sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center',
            p: 4,
            textAlign: 'center'
          }}
        >
          <Typography 
            sx={{ 
              color: '#666',
              fontSize: '1.1rem',
              fontWeight: 500,
              maxWidth: '600px'
            }}
          >
            {error}
          </Typography>
        </Box>
      ) : (
        <Grid
          container
          spacing={2}
          sx={{
            display: 'grid',
            gridTemplateColumns: isMobile
              ? '1fr'
              : isTablet
              ? 'repeat(2, 1fr)'
              : 'repeat(4, 1fr)',
            gap: '20px',
          }}
        >
          {displayedProperties.map((property) => {
            const amenities = getPropertyAmenities(property);
            const hasImage = hasValidImage(property.image);
            const displayPrice = getDisplayPrice(property);
            const isRental = (property.category || property.commercial_catgory || '').toLowerCase() === 'rent';
            const timeAgo = getTimeAgo(property.createdAt);

            return (
              <Box
                key={property.id}
                sx={{
                  display: 'flex',
                  flexDirection: isMobile ? 'column' : 'row',
                  height: isMobile ? 'auto' : '200px',
                  bgcolor: '#fff',
                  border: '1px solid #D1D5DB',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  cursor: 'pointer',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: '0 8px 20px rgba(0,0,0,0.1)',
                  },
                }}
                onClick={() => handlePropertyClick(property.id)}
              >
                <Box
                  sx={{
                    width: isMobile ? '100%' : '50%',
                    height: isMobile ? '200px' : '100%',
                    position: 'relative',
                    overflow: 'hidden',
                  }}
                >
                  {hasImage ? (
                    <Box
                      component="img"
                      src={`data:image/png;base64,${property.image}`}
                      alt={property.property_name}
                      sx={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                      }}
                    />
                  ) : (
                    <Box
                      sx={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#f5f5f5',
                        border: '1px dashed #ccc'
                      }}
                    >
                      <Typography variant="body2" color="#888" textAlign="center" px={2}>
                        No images uploaded
                      </Typography>
                    </Box>
                  )}

                  {timeAgo && (
                    <Box
                      sx={{
                        position: 'absolute',
                        bottom: '8px',
                        right: '8px',
                        bgcolor: 'rgba(0, 0, 0, 0.7)',
                        color: '#fff',
                        px: '8px',
                        py: '4px',
                        borderRadius: '4px',
                        fontSize: '11px',
                        fontWeight: 500,
                        zIndex: 2,
                        fontFamily: 'Outfit, sans-serif',
                      }}
                    >
                      {timeAgo}
                    </Box>
                  )}
                </Box>

                <Box
                  sx={{
                    width: isMobile ? '100%' : '50%',
                    p: 1.5,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    boxSizing: 'border-box',
                    overflow: 'hidden',
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: 14,
                      fontWeight: 500,
                      color: '#000',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      mb: 0.5
                    }}
                  >
                    {property.property_name}
                  </Typography>

                  {property.added_by && property.added_by.full_name ? (
                    <Typography
                      sx={{
                        fontSize: 11,
                        color: '#626262',
                        fontWeight: 400,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        mb: 0.5
                      }}
                    >
                      by {property.added_by.full_name}
                    </Typography>
                  ) : (
                    <Box sx={{ height: '16px', mb: 0.5 }} />
                  )}

                  <Typography
                    sx={{
                      fontSize: 11,
                      color: '#626262',
                      fontWeight: 400,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      mb: 0.5
                    }}
                  >
                    {property.area_name}, {property.location}
                  </Typography>

                  {amenities.length > 0 && (
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '3px',
                        mb: 0.5
                      }}
                    >
                      {amenities.map((amenity, index) => (
                        <Box
                          key={index}
                          component="span"
                          sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                        >
                          {getAmenityIcon(amenity.type)}
                          <Typography
                            sx={{
                              fontSize: 11,
                              color: '#626262',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            {amenity.value}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  )}

                  <Typography
                    sx={{
                      fontWeight: 600,
                      color: '#2563EB',
                      fontSize: 15,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      width: '100%'
                    }}
                  >
                    {displayPrice ? (
                      <>
                        ₹ {formatPrice(displayPrice)}
                        {isRental && '/month'}
                      </>
                    ) : (
                      'Price on Request'
                    )}
                  </Typography>
                </Box>
              </Box>
            );
          })}
        </Grid>
      )}
    </Box>
  );
};

export default ResidentialProperties;
